import React from "react";
import { Modal } from "react-bootstrap";
import Lottie from "react-lottie";
import "./Success_Modal.css";
import animationData from "./Success_Modal.json";

const Success_Modal_LogOut = ({
  show,
  onHide,
  successText = "Operation completed successfully!",
}) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
    },
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="sm"
      className="Success_Modal"
      backdrop="static"
    >
      <Modal.Body className="text-center">
        <div className="Success_sparcle_lottie_icon">
          <Lottie
            options={defaultOptions}
            height={150}
            width={150}
            isClickToPauseDisabled
          />
        </div>

        <p className="success_text">{successText}</p>
      </Modal.Body>
    </Modal>
  );
};

export default Success_Modal_LogOut;
